import { Component } from '@angular/core';

import { SkyFileItem } from '../../core';


export class SkyAvatarDemoComponent {
  public name = 'Robert C. Hernandez';
  public showImage = true;
  public avatarUrl: string | File = 'https://imgur.com/tBiGElW.png';

  public get src(): string | File {
    return this.showImage ?  this.avatarUrl : undefined;
  }

  public updateSrc(fileItem: SkyFileItem) {
    /*
      This is where you might upload the new avatar,
      but for this demo we'll just update it locally.
    */
    if (fileItem) {
      this.avatarUrl = fileItem.file;
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-avatar-demo',
  template: `<sky-avatar
  [name]="name"
  [src]="src"
  [canChange]="true"
  (avatarChanged)="updateSrc($event)">
</sky-avatar>
<sky-checkbox
  [(ngModel)]="showImage">
  <sky-checkbox-label>Show image</sky-checkbox-label>
</sky-checkbox>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
